import { render } from "./DashboardViewV2.vue?vue&type=template&id=0ed5d172"
import script from "./DashboardViewV2.vue?vue&type=script&lang=js"
export * from "./DashboardViewV2.vue?vue&type=script&lang=js"

import "./DashboardViewV2.vue?vue&type=style&index=0&id=0ed5d172&lang=css"
import "./DashboardViewV2.vue?vue&type=style&index=1&id=0ed5d172&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__